import DateFieldFormValue from "../ReusableFormValues/DateFieldFormValue";
import SubTypeDocumentSelector from "../SubTypeDocumentSelector";
import { addressVerificationDocumentTypesArray } from "./constants";

interface Props {
  readonly: boolean;
}

const AddressVerificationFormValues = ({ readonly }: Props) => {
  return (
    <>
      <SubTypeDocumentSelector
        readonly={readonly}
        subTypeDocuments={addressVerificationDocumentTypesArray}
        placeholder="Select an address verification document type"
        name="secondaryDocumentType"
        label="Document sub-type"
      />
      <DateFieldFormValue
        name="date"
        readonly={readonly}
        maxDate={new Date()}
        showExpiredWarning
      />
    </>
  );
};

export default AddressVerificationFormValues;
